import React from 'react';
import { tomoIncludes } from '../data/content';
export function IncludesSection() {
  return <section className="w-full bg-ink-800 px-4 pb-10 sm:px-6 sm:pb-14" data-id="element-119" data-mp="2dppxjeukztkf">
      <div className="mx-auto max-w-3xl rounded-2xl border border-white/15 bg-ink-900 p-5 sm:p-7" data-id="element-120" data-mp="2dslwn6i60oag">
        <h2 className="text-center text-lg font-extrabold uppercase tracking-wide text-gold-500 sm:text-2xl" data-id="element-121" data-mp="240g3htg6g0to">
          Cada tomo incluye:
        </h2>

        <ul className="mt-5 space-y-2.5" data-id="element-122" data-mp="1z24s3ea8hi9c">
          {tomoIncludes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-123" data-mp="1uyoyyrxdi01e">
              <span aria-hidden="true" className="text-sm leading-relaxed" data-id="element-124" data-mp="1q0nhucjicask">
                ✅
              </span>
              <span className="text-[13px] leading-relaxed text-neutral-200 sm:text-sm" data-id="element-125" data-mp="1l23tk5hfymx1">
                {item}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}